/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, forwardRef } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";

/** Utilities */
import { decryptUrlData } from "../../../services/CryptoService";

/** Common Components */
import CardSection from "../../../components/ui/card/CardSection";

/** RTK Query */
import {
  useGetAllProjectTeamListMutation,
} from "../../../app/services/projectTeamManagementAPI";

/** Lazily Loaded Component */
import AddProjectTeamManagement from "./projectTeamManagement/AddProjectTeam";

const ProjectTeamManagement = forwardRef((props, ref) => {

  let projectId = 0;
  let projectName = "";
  let projectCode = "";

  const { id } = useParams();
  const projectdata = id ? decryptUrlData(id) : null;

  if (typeof projectdata === "object" && projectdata !== null) {
    projectId = projectdata.projectId;
    if (projectdata.projectName) {
      projectName = projectdata.projectName;
      projectCode = projectdata.projectCode;
    }
  } else if (projectdata) {
    projectId = projectdata;
  }
  /* State*/
  const [showModal, setShowModal] = useState(false);
  const [setProjectTeamGridData] = useState();
  // API'S Call
  
  const [getAllProjectTeamList, {
    isLoading: isProjectTeamListLoading,
    isSuccess: isProjectTeamListSuccess,
    data: isLProjectTeamListData,
  },] = useGetAllProjectTeamListMutation();

  // const [deleteProjectTeam,
  //   { isSuccess: isDeleteSuccess,
  //     data: ProjectTeamDataDelete
  //   },] = useDeleteProjectTeamMutation();

  /* useEffects */
  useEffect(() => {
    if (projectId) {
      getProjectTeamDataList();
    }
  }, [projectId]);

  useEffect(() => {
    if (isProjectTeamListSuccess && isLProjectTeamListData) {
      if (isLProjectTeamListData) {
        setProjectTeamGridData(isLProjectTeamListData.dataSource);
      }
    }
  }, [isProjectTeamListSuccess, isLProjectTeamListData]);

  // useEffect(() => {
  //   if (isDeleteSuccess && ProjectTeamDataDelete) {
  //     ToastService.success(ProjectTeamDataDelete.errorMessage);
  //     getProjectTeamDataList();
  //   }
  // }, [isDeleteSuccess, ProjectTeamDataDelete]);
  //** Funcation's */
  const getProjectTeamDataList = () => {
    const request = {
      pagination: {
        pageNumber: 1,
        pageSize: 40,
      },
      filters: {
        searchText: props.search,
      },
      projectId: projectId,
    };
    getAllProjectTeamList(request);
  };

  const handleProjectTeamModal = () => {
    setShowModal(!showModal);
    getProjectTeamDataList();
  };

  return (
    <div className="table-style">
      <div className="project-team center-top-space">
        {/* Filter Section Start */}
        <div className="row">
          <div className="col-12">
            <div className="main-filter-section project-team-sec">
              <CardSection
                isContentLoading={isProjectTeamListLoading}
                // cardTitle={projectName + "Project Teams"}
                cardTitle={`${projectCode || ''} - ${projectName || ''} Team`}
              >
                <div className="row mb-2">
                  <div className="col-6">
                    <div className="filter-shorting-sec">
                      <div className="right-side-section">
                        <div className="add-project-team">
                          <AddProjectTeamManagement
                            onClose={handleProjectTeamModal}
                            projectId={projectId}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </CardSection>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

ProjectTeamManagement.propTypes = {
  search: PropTypes.string,
};
export default ProjectTeamManagement;
